import { combineReducers } from '@reduxjs/toolkit';
import config from './ConfigState/ConfigState.reducer';
import command from './CommandState/CommandState.reducer';
import appMode from './AppModeState/AppModeState.reducer';
import mopOnFile from './MopOnFileState/MopOnFileState.reducer';
import payment from './PaymentState/PaymentState.reducer';
export default combineReducers({
  appMode: appMode,
  command: command,
  config: config,
  mopOnFile: mopOnFile,
  payment: payment
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/rootReducer.js
// module id = 4527
// module chunks = 11